"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DETAIL_ITEM_VIDEO = void 0;
const DETAIL_ITEM_VIDEO = exports.DETAIL_ITEM_VIDEO = 'detail-item-video';
